// client/src/api/seasonService.js — R34d : saisons classées
import api from './api';

export const getSeasonState = async () => {
  try {
    const r = await api.get('/season');
    return r.data;
  } catch (e) {
    return { success: false };
  }
};

export const claimSeasonReward = async (masterCardId) => {
  const r = await api.post('/season/claim', { masterCardId });
  return r.data;
};
